import { ChevronDown, X } from "lucide-react";
import { motion } from "motion/react";

/**
 * Animated icon that morphs between ChevronDown and X
 * Uses rotation animation for smooth transition
 */
export function AnimatedDropdownIcon({ isOpen, size = 14, className = "" }) {
    return (
        <motion.div
            animate={{ rotate: isOpen ? 180 : 0 }}
            transition={{ duration: 0.2, ease: "easeInOut" }}
            className={className}
        >
            {isOpen ? (
                <X size={size} className="text-muted-foreground" />
            ) : (
                <ChevronDown size={size} className="text-muted-foreground" />
            )}
        </motion.div>
    );
}

/**
 * Animated hamburger icon that morphs to X
 * @param {boolean} isOpen - Whether the menu is open
 * @param {number} size - Size of the icon (used for container width/height)
 * @param {string} className - Additional classes
 */
export function AnimatedMenuIcon({ isOpen, size = 22, className = "" }) {
    const iconSize = size / 22 * 20; // Scale bar width based on size

    return (
        <div
            className={`relative flex flex-col justify-center items-center ${className}`}
            style={{ width: size, height: size }}
        >
            <motion.span
                animate={{
                    rotate: isOpen ? 45 : 0,
                    y: isOpen ? 0 : -4,
                }}
                transition={{ duration: 0.2 }}
                className="absolute h-0.5 bg-current rounded-full"
                style={{ width: iconSize }}
            />
            <motion.span
                animate={{
                    opacity: isOpen ? 0 : 1,
                    scaleX: isOpen ? 0 : 1,
                }}
                transition={{ duration: 0.15 }}
                className="absolute h-0.5 bg-current rounded-full"
                style={{ width: iconSize }}
            />
            <motion.span
                animate={{
                    rotate: isOpen ? -45 : 0,
                    y: isOpen ? 0 : 4,
                }}
                transition={{ duration: 0.2 }}
                className="absolute h-0.5 bg-current rounded-full"
                style={{ width: iconSize }}
            />
        </div>
    );
}
